import { IUnit } from '@numeo/types-core'
import { FormControl, FormLabel, Input, Select, Stack, Option } from '@mui/joy'
import React from 'react'

interface Dimensions {
    length: IUnit
    quantity?: number
}

interface DimensionFieldGroupProps {
    dimensions: Dimensions | null
    onChange: (dimensions: Dimensions | null) => void
    disabled?: boolean
}

export const DimensionFieldGroup: React.FC<DimensionFieldGroupProps> = ({ dimensions, onChange, disabled = false }) => {
    const currentDimensions = dimensions || {
        length: { value: 0, unit: 'in' },
        quantity: 0,
    }

    const handleLengthChange = (value: string, isUnit: boolean = false) => {
        const updated = { ...currentDimensions }
        if (isUnit) {
            updated.length = { ...updated.length, unit: value || 'in' }
        } else {
            const numValue = parseFloat(value)
            updated.length = { ...updated.length, value: isNaN(numValue) ? 0 : numValue }
        }
        onChange(updated)
    }

    const handleQuantityChange = (value: string) => {
        const numValue = parseInt(value)
        onChange({
            ...currentDimensions,
            quantity: isNaN(numValue) ? 0 : numValue,
        })
    }

    const commonUnit = currentDimensions.length.unit || 'in'

    return (
        <FormControl>
            <FormLabel>Dimensions</FormLabel>
            <Stack spacing={1.5}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Input
                        placeholder="Length"
                        type="number"
                        value={currentDimensions.length.value || ''}
                        onChange={(e) => handleLengthChange(e.target.value)}
                        disabled={disabled}
                        size="sm"
                        sx={{ flex: 1 }}
                        startDecorator="L:"
                    />
                    <Select
                        value={commonUnit}
                        onChange={(_, value) => {
                            if (value) {
                                handleLengthChange(value, true)
                            }
                        }}
                        disabled={disabled}
                        size="sm"
                        sx={{ minWidth: 80 }}
                    >
                        <Option value="in">in</Option>
                        <Option value="ft">ft</Option>
                        <Option value="cm">cm</Option>
                        <Option value="m">m</Option>
                    </Select>
                </Stack>
                <Input
                    placeholder="Quantity"
                    type="number"
                    value={currentDimensions.quantity || ''}
                    onChange={(e) => handleQuantityChange(e.target.value)}
                    disabled={disabled}
                    size="sm"
                    startDecorator="Qty:"
                />
            </Stack>
        </FormControl>
    )
}
